module.exports = __webpack_public_path__ + "img/emoji-pin@3x.a0463dd.png";